import { FacebookOutlined, InstagramOutlined } from '@ant-design/icons';
import kakaoChannelBanner from '@assets/images/kakaoChannelBanner.png';
import { Row, Space } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

// 1. 이미지 크기를 반응형으로 조절
const BannerImage = styled.img`
  width: 90%;          /* 웹뷰/모바일에서 화면의 90%를 차지하도록 설정 */
  max-width: 500px;    /* PC 웹에서도 너무 무식하게 커지지 않도록 마지노선 정함 */
  height: auto;
  object-fit: contain;
  cursor: pointer;
  margin-bottom: 15px; /* 하단 요소와 간격 확보 */

  @media (max-width: 480px) {
    width: 100%;       /* 아주 작은 화면(아이폰 SE 등)에서는 꽉 차게 */
  }
`;

const PassportFooter: FC = () => {
  return (
    <FooterContainer>
      <Row style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        {/* 2. 배너를 감싸는 div의 너비를 유동적으로 설정 */}
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '10px' }}>
          <BannerImage src={kakaoChannelBanner} alt="kakaoChannelBanner" />
        </div>

        <Space>
          <FollowDhlFont>Follow DHL: </FollowDhlFont>
          <Space>
            <NaverIcon onClick={() => window.open('https://blog.naver.com/dhl_story')} />
            <FacebookOutlined
              onClick={() => window.open('https://www.facebook.com/DHLExpressKorea')}
              style={{ fontSize: '2em', color: '#3b5998', cursor: 'pointer' }}
            />
            <InstagramOutlined
              onClick={() => window.open('https://instagram.com/dhl.korea')}
              style={{ fontSize: '2em', color: '#e1306c', cursor: 'pointer' }}
            />
          </Space>
        </Space>

        <div style={{ marginTop: '5px' }}>
          <a data-document-language="true" className="link ot-sdk-show-settings">쿠키 설정</a>
          <MarginFont>{' | '}</MarginFont>
          <BoldRedFont onClick={() => window.open('https://www.dhl.com/discover/ko-kr/privacy')}>
            개인정보 처리방침
          </BoldRedFont>
          <MarginFont>{' | '}</MarginFont>
          <RedFont onClick={() => window.open('http://www.dhl.co.kr/ko/express/shipping/shipping_advice/terms_conditions.html')}>
            운송 약관
          </RedFont>
          <MarginFont style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.logistics.dhl/kr-ko/home.html')}>
            {'©2022 DHL Express All right reserved.'}
          </MarginFont>
        </div>
      </Row>
    </FooterContainer>
  );
};

// 3. 푸터 높이를 내용에 맞게 유동적으로 변경 (기존 100px은 배너 추가 시 작을 수 있음)
const FooterContainer = styled.div`
  width: 100vw;
  min-height: 150px; 
  padding: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: #f8f8f8; /* 배경색이 필요하다면 추가 */
`;

const FollowDhlFont = styled.div`
  font-size: 160%;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-right: 15px;
  color: rgb(60, 72, 88);

  @media (max-width: 768px) {
    font-size: 120%; /* 모바일에서 폰트 크기 조절 */
  }
`;

const NaverIcon = styled.a`
  :before {
    font-weight: 900;
    color: green;
    content: 'N';
    font-size: 2em;
  }
`;

const BoldRedFont = styled.a`
  color: rgb(212, 5, 17);
  cursor: pointer;
  font-weight: bold;
`;

const RedFont = styled.a`
  color: rgb(212, 5, 17);
  cursor: pointer;
`;

const MarginFont = styled.span``;
export default PassportFooter;
